import { ICopyChecklistEntregaAmbienteUseCase } from "../../../presentation/useCases/create/copy_checklist_entrega_ambiente_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CopyChecklistEntregaAmbienteUseCase
 */

export class CopyChecklistEntregaAmbienteUseCase implements ICopyChecklistEntregaAmbienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idChecklistEntregaAmbiente: number,
    ordem?: string,
    descricao?: string,): Promise<void> {
    await this.repository.copiaChecklistEntregaAmbiente(
      idChecklistEntregaAmbiente,
      ordem,
      descricao
    );
  }
}
